import View from './view';
export const PollsButton = View;
